import { SteeringUser } from '@/stores/auth'
import { computed, MaybeRefOrGetter, toValue } from 'vue'

export function usePersonName(user: MaybeRefOrGetter<SteeringUser>) {
  return computed(() => {
    const _user = toValue(user)
    const firstName = (_user?.firstName ?? '').trim()
    const lastName = (_user?.lastName ?? '').trim()
    const username = _user.username.trim()
    const name = [firstName, lastName].join(' ').trim()
    const initials =
      firstName && lastName
        ? [firstName[0], lastName[0]]
        : lastName
          ? [lastName[0]]
          : firstName
            ? [firstName[0]]
            : [username[0]]
    return {
      name,
      username,
      initials: initials.join('').toUpperCase(),
    }
  })
}

export function getFilenameFromURL(url: string, defaultValue?: string) {
  const basename = (url.split(/[\\/]/).pop() as string).trim()
  return !basename && defaultValue ? defaultValue : basename
}

export function ensureError(error: unknown) {
  return error instanceof Error ? error : new Error(String(error))
}

export function makeRandomString(length: number, options?: { alphabet?: string }) {
  const alphabet =
    options?.alphabet ?? 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const alphabetLength = alphabet.length
  let result = ''
  let counter = 0
  while (counter < length) {
    result += alphabet.charAt(Math.floor(Math.random() * alphabetLength))
    counter += 1
  }
  return result
}

export function makeInsecureRandomId() {
  try {
    return crypto.randomUUID()
  } catch {
    return makeRandomString(36)
  }
}
